import Vue from 'vue'
import Router from 'vue-router'
import { store } from '@/store/store'

import NotFoundView from '@/components/error/404.vue'

import Dashboard from '@/components/view/dashboard/Dashboard'
import WelcomeMessage from '@/components/view/welcomemessage/WelcomeMessage'

import Account from '@/components/view/allbots/Account'
import Template from '@/components/view/template/Template'
import Broadcast from '@/components/view/broadcast/Broadcast'
import Conversation from '@/components/view/intent/Conversation'
import Comment from '@/components/view/intent/CommentToInbox'
import Training from '@/components/view/intent/Training'
import Billing from '@/components/view/billing/Billing'
import Upgrade from '@/components/view/billing/Upgrade'

import OrderSummaryLine from '@/components/view/template/ecommerce/OrderSummaryLine'
import Chat from '@/components/view/chat/Chat'
import Setup from '@/components/view/getstarted/Setup'
import SetupC2p from '@/components/view/chat2pay/SetupC2p'

import LivechatView from '@/components/view/livechat/LivechatView'

Vue.use(Router)

const allLang = ['en', 'th', 'la']

const routes = [
  {
    path: '/',
    beforeEnter(to, from, next) {
      let language = to.params.lang
      if (!allLang.includes(language)) {
        return next('en')
      }
      store.dispatch('setLang', language)

      return next()
    }
  },
  {
    path: '/linenotify',
    beforeEnter: guardRoute,
    component: {
      name: 'lang',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        component: function(resolve) {
          require(['@/components/view/linenotify/Linenotify.vue'], resolve)
        }
      }
    ]
  },
  {
    path: '/:lang',
    beforeEnter(to, from, next) {
      let language = to.params.lang
      if (!allLang.includes(language)) {
        return next('en')
      }
      store.dispatch('setLang', language)

      return next()
    },
    component: {
      name: 'lang',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        redirect: 'allbots'
      },
      {
        path: 'login',
        name: 'login',
        component: function(resolve) {
          require(['@/components/login/Login.vue'], resolve)
        }
      },
      {
        path: 'nigol',
        name: 'nigol',
        component: function(resolve) {
          require(['@/components/login/Nigol.vue'], resolve)
        }
      },
      {
        path: 'chat2pay',
        name: 'chat2pay',
        component: function(resolve) {
          require(['@/components/login/Chat2Pay.vue'], resolve)
        },
        meta: {
          title: 'Chat2pay'
        }
      },
      {
        path: 'allbots',
        name: 'allbots',
        component: Account,
        beforeEnter: guardRoute,
        meta: {
          title: 'All Bots'
        }
      },
      {
        path: 'ordersummary',
        name: 'ordersummary',
        component: OrderSummaryLine,
        meta: {
          title: 'Order Summary'
        }
      },
      {
        path: 'chat',
        name: 'chat',
        component: Chat,
        meta: {
          title: 'Chat'
        }
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        component: Dashboard,
        beforeEnter: guardRoute,
        meta: {
          title: 'Dashboard'
        }
      },
      {
        path: 'welcome',
        name: 'welcome message',
        component: WelcomeMessage,
        beforeEnter: guardRoute,
        meta: {
          title: 'Welcome Message'
        }
      },
      {
        path: 'conversation',
        name: 'conversation',
        component: Conversation,
        beforeEnter: guardRoute,
        meta: {
          title: 'Conversations'
        }
      },
      {
        path: 'livechat',
        name: 'livechat',
        component: LivechatView,
        beforeEnter: guardRoute,
        meta: {
          title: 'Livechats'
        }
      },
      {
        path: 'broadcast',
        name: 'broadcast',
        component: Broadcast,
        beforeEnter: guardRoute,
        meta: {
          title: 'Broadcast'
        }
      },
      {
        path: 'template',
        name: 'template',
        component: Template,
        beforeEnter: guardRoute,
        meta: {
          title: 'Plugin'
        }
      },
      {
        path: 'billing',
        name: 'setting',
        component: Billing,
        beforeEnter: guardRoute,
        meta: {
          title: 'Setting'
        }
      },
      {
        path: 'comment',
        name: 'Comment to inbox',
        component: Comment,
        beforeEnter: guardRoute,
        meta: {
          title: 'Reply comment'
        }
      },
      {
        path: 'training',
        name: 'Training',
        component: Training,
        beforeEnter: guardRoute,
        meta: {
          title: 'Training'
        }
      },
      {
        path: 'setup',
        name: 'Setup',
        component: Setup,
        beforeEnter: guardRoute,
        meta: {
          title: 'Get Started'
        }
      },
      {
        path: 'setup_c2p',
        name: 'setup_c2p',
        component: SetupC2p,
        beforeEnter: guardRoute,
        meta: {
          title: 'Setup Chat2Pay'
        }
      },
      {
        path: 'upgrade',
        name: 'Upgrade',
        component: Upgrade,
        beforeEnter: guardRoute,
        meta: {
          title: 'Upgrade package to premium plan'
        }
      },
      {
        // not found handler
        path: '*',
        component: NotFoundView
      }
    ]
  }
]

const router = new Router({
  routes,
  mode: 'history'
})

const title = 'ZWIZ.AI Chatbot'
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title)

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags)
  const previousNearestWithMeta = from.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags)

  // If a route with a title was found, set the document (page) title to that value.
  if (['chat2pay', 'setup_c2p'].includes(to.name)) {
    document.title = nearestWithTitle.meta.title
  } else if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title + ' | ' + title
  } else {
    document.title = title
  }

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el =>
    el.parentNode.removeChild(el)
  )

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next()

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags
    .map(tagDef => {
      const tag = document.createElement('meta')

      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key])
      })

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute('data-vue-router-controlled', '')

      return tag
    })
    // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag))

  next()
})

export default router

function guardRoute(to, from, next) {
  if (!store.getters.isLoggedIn) {
    next({
      path: '/' + store.getters.currentLang + '/login',
      query: { redirect: to.fullPath, utm_source: to.query.utm_source }
    })
  } else {
    if (store.state.isFacebook) {
      if (store.state.selectedBot) {
        store.dispatch('updateBotDetail').then(
          function(response) {
            // console.log(response)
          },
          function(e) {
            next({
              path: '/' + store.getters.currentLang + '/login',
              query: { redirect: to.fullPath, utm_source: to.query.utm_source }
            })
          }
        )
      }
      next()
    } else {
      if (store.state.selectedBot) {
        store.dispatch('updateBotDetail').then(
          function(response) {
            // console.log(response)
          },
          function(e) {
            next({
              path: '/' + store.getters.currentLang + '/nigol',
              query: { redirect: to.fullPath, utm_source: to.query.utm_source }
            })
          }
        )
      }

      next()
    }
  }
}



// WEBPACK FOOTER //
// ./src/router/index.js